import { useNavigate } from 'react-router';
import * as R from '@/Router/routes';
import { Application } from '@/api/getClientApplication';

function useNavigateWithUpsaleResolution() {
  const navigate = useNavigate();
  const navigateWithUpsaleResolution = (application: Application): void => {
    if (application?.resolution === 'REJECTED') {
      navigate(R.LOAN_REJECTED);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionMessage === 'ASK_FOR_DOCUMENTS'
    ) {
      navigate(R.PSD2_BANKS);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionDetail === 'INSUFFICIENT_PSD2_INCOME'
    ) {
      navigate(R.DOCUMENT_UPLOAD);
      return;
    }

    if (
      application?.resolution === 'MANUAL' &&
      application?.resolutionMessage !== 'ASK_FOR_DOCUMENTS' &&
      application?.resolutionDetail !== 'INSUFFICIENT_PSD2_INCOME'
    ) {
      navigate(R.LOAN_CONFIRM);
      return;
    }

    // default redirect
    navigate(R.LOAN_CONFIRM);
  };

  return { navigateWithUpsaleResolution };
}

export default useNavigateWithUpsaleResolution;
